<template>
    <section
        v-if="props.activeSyncId === props.syncId"
        :id="props.tabPanelId"
        ref="tabPanelRef"
        class="focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-sky-700 rounded-b-lg"
        role="tabpanel"
        tabindex="-1"
    >
        <slot />
    </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';

type CardTabPanelProps = {
    syncId: string;
    tabPanelId: string;
    activeSyncId: string | null;
};

const props = defineProps<CardTabPanelProps>();
const tabPanelRef = ref<HTMLElement | null>(null);

function focus() {
    tabPanelRef.value?.focus();
}

defineExpose({
    focus,
});
</script>
